<template>
  <!-- <el-tabs v-model="activeName" type="card"> -->
    <div>
      <router-view />
        <Releases />
    </div>
    <!-- <el-tab-pane label="档案查询" name="first">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="日期"  width="180">
        </el-table-column>
        <el-table-column prop="name"  label="姓名" width="180">
        </el-table-column>
        <el-table-column prop="address" label="地址">
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="团体发布" name="second">团体发布</el-tab-pane>
    <el-tab-pane label="测评查询系统" name="third">测评查询系统</el-tab-pane> -->
    <!-- <el-tab-pane label="预约发布" name="fourth">
        <Releases />
    </el-tab-pane> -->
  <!-- </el-tabs> -->
</template>
<script>
import Releases from './Releases' 
export default {
  data(){
    return {
       activeName: 'first',
    }
  },
  components:{
    Releases
  },
  methods:{
  }
}
</script>